import {ngcAnimations} from '@app/core/comp/animations';
import {Component, Input, OnDestroy, OnInit, SecurityContext} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeHtml, SafeResourceUrl} from '@angular/platform-browser';
import {ActivatedRoute, Params} from '@angular/router';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {NavbarService} from '@app/core/comp/navigation/navbar.service';

@Component({
    selector   : 'ngc-ann-content-viewer',
    templateUrl: './ann-content-viewer.component.html',
    styleUrls  : ['./ann-content-viewer.component.scss'],
    animations : ngcAnimations
})
export class AnnouncementContentViewerComponent implements OnInit, OnDestroy {

    @Input() format: string;
    @Input() applicationName: string;
    @Input() isHtmlDocumentLoading$ = new BehaviorSubject(false);
    @Input()
    set documentUrl(url: string) {

        this._documentUrl = url;

        if (this.format === 'html')  {
            this.saveUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this._documentUrl);
            this.isHtmlDocumentLoading$.next(true);
            this.http.get(this._documentUrl, {responseType: 'text'})
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(res => {
                    if (this.applicationName && res) {
                        res = res.replace(/%application.name%/g, this.applicationName);
                    }

                    if (this.activatedRouteQueryParam === this.COOKIES_QUERY_PARAM) {
                        res = res.replace(`>4. Use of cookies`, `class="cookies-block">4. Use of cookies`);
                    }

                    this.htmlContent = this.domSanitizer.sanitize(SecurityContext.HTML, <string>res);
                    this.isHtmlDocumentLoading$.next(false);

                    setTimeout(() => {
                        NavbarService.scrollToTheTop('.cookies-block');
                    }, 0);

                }, error => {
                    console.log(error);
                    this.isHtmlDocumentLoading$.next(false);
                });
        } else {
            this.getPdf(url);
        }
    }
    get documentUrl() {
        return this._documentUrl;
    }

    message: string;
    saveUrl: any;
    htmlContent: string;
    activatedRouteQueryParam: string;
    readonly QUERY_PARAM = 'bookmark';
    readonly COOKIES_QUERY_PARAM = 'cookies';
    private _documentUrl: string;
    private _objectUrl: string | null = null;
    private unsubscribe$ = new Subject<void>();

    constructor(
        private http: HttpClient,
        private domSanitizer: DomSanitizer,
        private activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe( (params: Params) => {
            this.activatedRouteQueryParam = params[this.QUERY_PARAM];
        });
    }

    ngOnInit(): void {
    }

    getPdf(url: string): void {
        this.http.get(url, {responseType: 'blob'})
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(blob => {
                if (this._objectUrl) {
                    URL.revokeObjectURL(this._objectUrl);
                }
                this._objectUrl = URL.createObjectURL(blob);
                this.saveUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this._objectUrl);
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();

        if (this._objectUrl) {
            URL.revokeObjectURL(this._objectUrl);
            this._objectUrl = null;
        }
    }
}
